import _ from 'underscore';
import get from 'lodash/get';
import * as ACTIONS_NAME from '../actions/carousel';
import Utils from '../utils/Utils';
import { CAROUSEL } from '../constants';

const TYPE_HIGHLIGHT = 'Highlight';
const FAVORITED_CARROUSEL = 'favorited';
const LIVE_REGEX = /live=/g;

const initialState = {
  recomendations: null,
  cmsLevel: null,
  findById: {},
  carrousels: [],
  favorites: [],
  seenList: [],
  imageBGHandler: { active: false },
};

// eslint-disable-next-line consistent-return
const filterData = options => {
  const { components, name, type: optionsType, deepType, large } = options;
  const data = [];
  let typeParent = optionsType || null;

  if (options.simple) {
    let id;
    let url;
    let type;
    let title;
    let byuser;
    let offset = null;

    components.map(component => {
      if (component.type === TYPE_HIGHLIGHT && component) {
        url = component.properties?.url;
        type = TYPE_HIGHLIGHT;
      }

      if (component.name === 'carrousel') {
        url = component.properties.url || url;
        id = component.properties.id || id;
        type = component.type || type;
        typeParent = options.type !== null ? options.type.toUpperCase() : null;

        if (component.properties.type === FAVORITED_CARROUSEL) {
          const hasLiveParamInUrl = LIVE_REGEX.test(url);
          if (!hasLiveParamInUrl) url += '&live=true';
        }
      }

      title = component.properties.large || title;
      byuser = component.properties.byuser || byuser;
      offset = component.properties.offset || offset;

      // eslint-disable-next-line consistent-return
      return component;
    });

    return {
      id,
      title,
      url,
      type,
      byuser,
      name,
      typeParent,
      data,
      offset,
      large,
      deepType,
    };
  }

  if (!options.simple) {
    let title;
    const byuser = 'true';

    const carrousels = components
      .map(component => {
        if (component.name === 'headerizq' || component.name === 'headerder') {
          title = component.properties.large;
        }

        if (
          component.name === 'carrouselizq' ||
          component.name === 'carrouselder'
        ) {
          let id;

          let url;

          const type = null;
          return {
            url: component.properties.url || url,
            id: component.properties.id || id,
            byuser: component.properties.byuser || byuser,
            type: component.type || type,
            typeParent:
              options.type !== null ? component.type.toUpperCase() : null,
            name: component.name,
            title,
            data,
            large,
            deepType,
          };
        }

        return false;
      })
      .filter(component => component);

    return {
      name,
      carrousels,
      type,
      typeParent,
      data,
      byuser,
      large,
      deepType,
    };
  }
};

const parseCarrousels = options => {
  const { components, name, type, deepType, large } = options;
  let simple = true;

  if (type === 'carrouseldoble') {
    simple = false;
  }

  return filterData({ components, name, simple, type, deepType, large });
};

export default function carousel(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_NAME.CONST_SET_CONTENT_LIST: {
      const { findById } = state;
      const { result } = action;
      const groups = result.data.response.groups || [];
      const { _id } = result;
      let recordingList = state.recordingList || [];
      let dataRecording = null;

      if (
        groups.length == 0 &&
        Array.isArray(result.data.response.recordings)
      ) {
        recordingList = recordingList.concat(result.data.response.recordings);
        result.data.response.recordings.map(item => {
          const obj = Object.assign(item.channel.event, {
            channel_id: item.channel.id,
          });
          groups.push(obj);
        });
      }

      if (recordingList.length > 0) {
        dataRecording = {
          recordingList,
        };
      }

      findById[_id] = {
        groups,
        name: getNameByRequest(result.options.url),
      };

      const setDataToStore = {
        findById,
      };

      if (result.options.isMyList) {
        setDataToStore.favorites = groups;
      }

      if (result.options.isSeenList) {
        setDataToStore.seenList = groups;
      }

      return Object.assign({}, state, setDataToStore, dataRecording);
    }

    case ACTIONS_NAME.SET_CAROUSEL_DATA: {
      const id = get(action, 'result.options.id', '-1');
      const data = get(action, 'result.data.response.components', []);
      const store = Object.assign({}, state);
      store.carrousels.map(e => {
        if (e.id === id) {
          e.data = data;
          return e;
        }
      });
      return Object.assign({}, state, { carrousels: store.carrousels });
    }

    case ACTIONS_NAME.CONST_SET_CMS_LEVEL: {
      if(action.data.msg === "ERROR") return {...state}
      let newCarrousels = action.data.response?.modules.module;
      let isInfiniteList = false;

      if (
        newCarrousels.length === 1 &&
        newCarrousels[0].type === 'listadoinfinito'
      ) {
        isInfiniteList = true;
      }

      newCarrousels = newCarrousels.map(module => {
        const options = {
          components: module.components.component,
          name: module.name,
          type: module.type,
          large: module.components?.component[1]?.properties?.large || '',
          deepType: module.components?.component[2]?.properties?.type || '',
        };
        const carrousel = parseCarrousels(options);
        return carrousel;
      });

      return Object.assign({}, state, {
        cmsLevel: action.data,
        carrousels: newCarrousels,
        isInfiniteList,
      });
    }
    // case ACTIONS_NAME.PUSH_CARROUSELS:

    //   const newCarrousel = action.carrousel;
    //   const carrousels = state.carrousels.push(newCarrousel);
    //   return state;

    case ACTIONS_NAME.CONST_SET_CMS_LEVEL_USER: {
      const unparsedCarrouselUser = action.data.response.modules.module;
      const currentCarrousels = _.unique(state.carrousels, 'name');
      /**
       *
       * Parse new Carousels
       *
       */
      const newParsedCarrousels = _.unique(
        unparsedCarrouselUser.map(module => {
          const options = {
            components: module.components.component,
            name: module.name,
            type: module.type,
          };

          const newCarrousel = parseCarrousels(options);
          return newCarrousel;
        }),
        'name',
      );
      /**
       *
       * Extend Carousels
       *
       */
      const currentCarrouselsMapped = currentCarrousels.map(
        currentCarrousel => {
          let nestedExtended = false;
          newParsedCarrousels
            .map(newCarrousel => {
              if (newCarrousel.name === currentCarrousel.name) {
                if (newCarrousel.type === 'carrouseldoble') {
                  currentCarrousel.carrousels = currentCarrousel.carrousels.map(
                    currentNestedCarrousel => {
                      const newNestedCarrousels = newCarrousel.carrousels.map(
                        newNestedCarrousel => {
                          if (
                            newNestedCarrousel.name ===
                            currentNestedCarrousel.name
                          ) {
                            currentNestedCarrousel.url = newNestedCarrousel.url;
                            nestedExtended = true;
                          }

                          return newNestedCarrousel;
                        },
                      );

                      return currentNestedCarrousel;
                    },
                  );
                } else {
                  currentCarrousel.url = currentCarrousel.url
                    ? currentCarrousel.url
                    : newCarrousel.url;
                  if (newCarrousel.offset) {
                    currentCarrousel.offset = newCarrousel.offset;
                  }
                }

                if (currentCarrousel.url || nestedExtended) {
                  currentCarrousel.extended = true;

                  if (currentCarrousel.url) {
                    const filterId = Utils.urlParamsToJson(currentCarrousel.url)
                      .filter_id;
                    if (filterId) currentCarrousel.filter_id = filterId;
                  }
                }

                newCarrousel = null;
              }

              return newCarrousel;
            })
            .filter(carousel => carousel);

          return currentCarrousel;
        },
      );

      return Object.assign({}, state, { carrousels: currentCarrouselsMapped });
    }

    case ACTIONS_NAME.SET_FAVORITES:
      return Object.assign({}, state, { favorites: action.favorites });

    case ACTIONS_NAME.FLUSH_OVERLOAD:
      return Object.assign({}, state, {
        findById: {},
        favorites: [],
        carrousels: [],
      });

    case ACTIONS_NAME.DELETE_FAVORITE: {
      const { favoriteId } = action;
      const favorites = state.favorites.filter(
        favorite => favorite.id !== favoriteId,
      );

      return Object.assign({}, state, { favorites });
    }

    case ACTIONS_NAME.CONST_SET_SEEN:
      return Object.assign({}, state, { seen: action.seen });

    case ACTIONS_NAME.REMOVE_SEEN_CAROUSEL: {
      const { group } = action;
      const seenList = state.seenList.filter(seen => seen.id !== group);
      return { ...state, seenList };
    }

    default:
      return state;
  }
}

function getNameByRequest(request) {
  if (request.includes('/services/user/seen')) {
    return CAROUSEL.ACTIVIDAD_RECIENTE;
  }
}
